(ns app.front.view.workspace.create-related
  "Events for handling signals that do :process.action/create-related-application"
  (:require [app.front.process :as process]
            [app.front.view.application-wizard.navigation :as wizard-nav]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(defn- workspace-id-from-changes [changes]
  (->> changes
       vals
       (some :workspace/id)
       second))


(rf/reg-event-fx ::do-navigate-workspace
  (fn [_ [_ _ changes]]
    {:route/push {:route  :view/workspace
                  :params {:workspace-id (workspace-id-from-changes changes)}}}))

(rf/reg-event-fx ::do-navigate-renewal
  (fn [_ [_ _ changes]]
    (let [workspace-id (workspace-id-from-changes changes)]
      {:route/push {:route  :view/application-wizard-workspace
                    :params {:workspace-id workspace-id
                             :step         wizard-nav/renewal-overview-step-path}}})))

(def ^:private renewal-signals
  #{:process.signal/renew-licence
    :process.signal/renew-registration})

(defn handler-fn [signal]
  (fn [_ [_ process-target]]
    {:dispatch [::process/signal
                process-target
                [signal]
                {:on-success [(if (and (contains? renewal-signals signal)
                                       (ff/enabled? :feature-flag.id/application-wizard))
                                ::do-navigate-renewal
                                ::do-navigate-workspace)]}]}))

(rf/reg-event-fx ::plans-resubmission
  (handler-fn :process.signal/plans-resubmission))

(rf/reg-event-fx ::begin-transfer-of-permit
  (handler-fn :process.signal/begin-transfer-of-permit))

(rf/reg-event-fx ::phased-plan-approval
  (handler-fn :process.signal/phased-plan-approval))

(rf/reg-event-fx ::renew-licence
  (handler-fn :process.signal/renew-licence))

(rf/reg-event-fx ::renew-contractor-registration
  (handler-fn :process.signal/renew-registration))

(rf/reg-event-fx ::create-licence-follow-up
  (handler-fn :process.signal/create-supplemental-workspace))
